import React from "react";

import { useForm, Controller } from "react-hook-form";

import { InputText } from "primereact/inputtext";
import "./directorDetails.scss";
import { Tooltip } from "primereact/tooltip";

const DetailsForm = (props) => {
  const { data } = props;

  const required = "*";

  const {
    control,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    defaultValues: {
      name: "",
      last_name: "",
      email: "",
      phone_code: "",
    },
  });

  return (
    <div className="details-form-container">
      <div className="form-header">
        <h4 className="m-0 mb-2">General Information</h4>
        <p className="m-0 mb-4">
          This section provides a general information about {data.name}
        </p>
        <p className="sub-heading ">Main</p>
      </div>
      <form>
        <div className="formgrid grid ">
          <div className="field input-item col-6">
            <Tooltip target=".given-name-tool-tip" />
            <label className="input-label">
              {`Given Name(s)${required}`}
              <span
                data-pr-tooltip="This is usually the person's first name or the name they usually go by."
                className="given-name-tool-tip ml-1 pi pi-info-circle"
              />
            </label>
            <input
              type="text"
              name="given_name"
              placeholder="Enter given name(s)"
              value={data?.name || ""}
              disabled={true}
              className={`input-field appearance-none outline-none w-full disable`}
            />
          </div>
          <div className="field input-item col-6 ">
            <Tooltip target=".other-name-tool-tip" />
            <label className="input-label">
              {`Other Name(s)`}{" "}
              <span
                data-pr-tooltip="Any middle or extra names that the employee has. You can leave this blank if it doesn’t apply."
                className="other-name-tool-tip ml-1 pi pi-info-circle"
              />
            </label>
            <input
              type="text"
              name="other_name"
              placeholder="Enter any other names, such as middle names or clan names"
              value={data?.other_name || ""}
              disabled={true}
              className={`input-field appearance-none outline-none w-full disable`}
            />
          </div>

          <div className="field input-item col-6 ">
            <Tooltip target=".surname-tool-tip" />
            <label className="input-label">
              {`Surname(s)`}{" "}
              <span
                data-pr-tooltip="This is usually a family name or last name. If employee has more than one, include them here."
                className="surname-tool-tip ml-1 pi pi-info-circle"
              />
            </label>
            <input
              type="text"
              name="surname"
              placeholder="Enter surname(s)."
              value={data?.last_name || ""}
              disabled={true}
              className={`input-field appearance-none outline-none w-full disable`}
            />
          </div>
          <div className="field input-item col-6 ">
            <Tooltip target=".preferred-name-tool-tip" />
            <label className="input-label">
              {`Preferred Name(s)`}{" "}
              <span
                data-pr-tooltip="If the employee wants to be called by a different name than their given name, put that here."
                className="preferred-name-tool-tip ml-1 pi pi-info-circle"
              />
            </label>
            <input
              type="text"
              name="preferred_name"
              placeholder="Preferred name or nickname"
              value={
                data?.preferred_name ||
                (data.name && `${data.name} ${data.last_name}`)
              }
              disabled={true}
              className={`input-field appearance-none outline-none w-full disable`}
            />
          </div>

          <div className="field col-6 mr-2">
            <label className="input-label">Contact Email{required}</label>
            <Controller
              name="email_id"
              control={control}
              defaultValues
              render={({ field }) => (
                <InputText
                  {...field}
                  value={data?.email}
                  type="text"
                  placeholder="Enter email address"
                  disabled={true}
                  className={`input-field appearance-none outline-none w-full disable`}
                />
              )}
            />
          </div>
          <div className="contact-label">
            <label>Phone Number</label>
          </div>
          <div className="grid field col-6 p-0 m-0">
            <div className="field col-3">
              <InputText
                optionLabel="name"
                placeholder="country code"
                highlightOnSelect={false}
                className="input-field w-full disable"
                name="phone_code"
                value={data?.phone_code}
                disabled={true}
              />
            </div>
            <div className="field col-9">
              <InputText
                className="input-field w-full disable"
                name="phone"
                value={data?.phone}
                disabled={true}
                placeholder="Enter phone number"
                control={control}
                defaultValues
                render={({ field }) => (
                  <InputText
                    {...field}
                    value={data?.phone || ""}
                    disabled={true}
                    type="text"
                    placeholder="Enter phone number"
                    className={`input-field appearance-none outline-none w-full disable`}
                  />
                )}
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default DetailsForm;
